import { createClient } from "@supabase/supabase-js";

// Both values are meant to be public - the "publishable" key (Supabase's
// current naming for what used to be called the anon key) is explicitly
// safe to ship in a browser bundle, same idea as a Stripe publishable key.
// VITE_ vars override for a different Supabase project (e.g. a staging one).
const url =
  import.meta.env.VITE_SUPABASE_URL ??
  "https://uqcdahhpzqxrrmktlbvi.supabase.co";
const publishableKey =
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ??
  "sb_publishable_6HHaCDEqHD7JP5_ZeKJ_Uw_alCW1s26";

export const supabase = createClient(url, publishableKey);
